module.exports = __webpack_public_path__ + "static/media/info.1e5c03c5.png";